export default __webpack_public_path__ + "static/media/background.ce8a8970.jpg";